"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var breadcrumbs = {
  textLink: {
    textLinkColorPrimaryDisabled: _color["default"].pickledBluewood800
  },
  separatorFontSize: _font["default"].sizeSm,
  separatorFontWeight: _font["default"].weightDefault,
  separatorPadding: '0 6px',
  separatorTextColor: _color["default"].pickledBluewood800
};
var _default = breadcrumbs;
exports["default"] = _default;